import React from "react";
import NmdfcSchemesContent from "./NmdfcSchemesContent";
import TermLoanSchemeContent from "./TermLoanSchemeContent";
import EducationLoanSchemeContent from "./EducationLoanSchemeContent";
import MicroFinanceSchemeContent from "./MicroFinanceSchemeContent";
import VirasatSchemeContent from "./VirasatSchemeContent";
import PromotionalSchemesContent from "./PromotionalSchemesContent";
import MaulanaAzadNationalFellowshipSchemeContent from "./MaulanaAzadNationalFellowshipSchemeContent";
import RefinancingThroughBanksContent from "./RefinancingThroughBanksContent";

const SchemesContent = ({ activeSection }) => {
  const renderContent = () => {
    switch (activeSection) {
      case "nmdfc-schemes":
        return <NmdfcSchemesContent />;

      case "term-loan-scheme":
        return <TermLoanSchemeContent />;

      case "education-loan-scheme":
        return <EducationLoanSchemeContent />;

      case "micro-finance-scheme":
        return <MicroFinanceSchemeContent />;

      case "virasat-scheme":
        return <VirasatSchemeContent />;

      case "promotional-schemes":
        return <PromotionalSchemesContent />;

      case "maulana-azad-national-fellowship-scheme":
        return <MaulanaAzadNationalFellowshipSchemeContent />;

      case "refinancing-through-banks":
        return <RefinancingThroughBanksContent />;

      default:
        return <NmdfcSchemesContent />;
    }
  };

  return (
    <section className="flex-1 rounded-lg p-5 md:p-[30px]">
      {renderContent()}
    </section>
  );
};

export default SchemesContent;
